import StoreBtn from "./StoreBtn";
import StarField from "./StarField";
import { useSectionTrack } from "../hooks/useSectionTrack";

export default function DownloadCTA() {
  const ref = useSectionTrack("download_cta");

  return (
    <section
      ref={ref}
      id="download"
      className="cta-outer"
      style={{ padding: "0 80px 100px", background: "transparent" }}
    >
      <div className="cta-inner cta-layout glass">
        <StarField density={0.7} />
        <div className="cta-glow-bottom" />
        <div className="cta-glow-top" />

        <div style={{ position: "relative", zIndex: 1 }}>
          <div className="cta-badge">Закрытая бета · Варшава</div>
          <h2 className="cta-headline">Хватит. Сходи уже куда-нибудь.</h2>
          <p className="cta-sub">
            Скачай, отметь свои категории — уведомление о ближайших ивентах приходит само.
            Сегодня же. Без листания инсташек и подписок на чаты.
          </p>
          <div className="store-btns" style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
            <StoreBtn kind="apple"  dark location="download_cta" />
            <StoreBtn kind="google" dark location="download_cta" />
          </div>
        </div>

        <div className="cta-logo-wrap">
          <div className="cta-logo-glow" />
          <img src="/logo.png" alt="Wychodzi" className="cta-logo" />
        </div>
      </div>
    </section>
  );
}
